const isLocal = false;
export const URLs = {
  domain: isLocal ? "http://localhost:5000" : "https://chefp.in",
  images: isLocal
    ? "http://localhost:5000/uploads/"
    : "https://chefp.in/uploads/",
};
